export default function Switch({ label, className, ...rest }) {
  return (
    <label className={['ui ui-switch', className].filter(Boolean).join(' ')}>
      <input type="checkbox" role="switch" {...rest} />
      <span className="ui-switch__track" aria-hidden="true"><span className="ui-switch__thumb" /></span>
      <span>{label}</span>
    </label>
  );
}
